import { FullPageCenter } from "../FullPageCenter";

export { NoBatchClasses };

const NoBatchClasses = () => {
  return (
    <FullPageCenter>
      <div
        style={{
          placeSelf: "center",
          textAlign: "center",
        }}
      >
        <h2>No Batch Classes Available</h2>
      </div>
      <div
        style={{
          placeSelf: "center",
          textAlign: "center",
        }}
      >
        <p>
          You haven’t been set up to access any batch classes. Please contact
          the system Administrator who can set up access for you.
        </p>
      </div>
    </FullPageCenter>
  );
};
